var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LayoutDefault",attrs:{"id":"LayoutDefault"}},[_c('Header'),_c('LeftBar',{attrs:{"id":"right-side-bar"}}),_c('RightBar',{attrs:{"id":"right-side-bar"}}),_c('main',{staticClass:"LayoutDefault__main"},[_c('transition',{attrs:{"name":"fade"}},[_vm._t("default")],2)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }